import CustomLikeButton from './CustomLikeButton';
import { openMessageSourceDialog } from './ViewMessageSourceDialog';
import getSenderNameForBlockMenuItem from '../utils/getSenderNameForBlockMenuItem';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { observer as observerLite } from 'mobx-react-lite';
import { CommandBarButton, IButtonProps } from 'office-ui-fabric-react/lib/Button';
import { CommandBar, ICommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { ContextualMenuItemType, DirectionalHint } from 'office-ui-fabric-react/lib/ContextualMenu';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { KeyCodes } from 'office-ui-fabric-react/lib/Utilities';
import { getReadHostItemIndex, shouldAddinsActivate } from 'owa-addins-core';
import { populateCommandBarWithAddins } from 'owa-addins-surface-actions';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { logUsage } from 'owa-analytics';
import { MailboxType } from 'owa-client-ids';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import { showInImmersiveReader } from 'owa-immersive-reader-store';
import { InboxRuleActionSource } from 'owa-inbox-rules-option';
import loc, { format, isStringNullOrWhiteSpace } from 'owa-localize';
import { itemHeaderBlock } from 'owa-locstrings/lib/strings/itemheaderblock.locstring.json';
import { itemHeaderFlag } from 'owa-locstrings/lib/strings/itemheaderflag.locstring.json';
import { itemHeaderLightsOn } from 'owa-locstrings/lib/strings/itemheaderlightson.locstring.json';
import { itemHeaderMarkAsJunk } from 'owa-locstrings/lib/strings/itemheadermarkasjunk.locstring.json';
import { mailEllipsisAriaLabelText } from 'owa-locstrings/lib/strings/mailellipsisarialabeltext.locstring.json';
import { markAsRead } from 'owa-locstrings/lib/strings/markasread.locstring.json';
import { markAsUnread } from 'owa-locstrings/lib/strings/markasunread.locstring.json';
import { MoreActionsButton } from 'owa-locstrings/lib/strings/moreactionsbutton.locstring.json';
import { reportAbuse } from 'owa-locstrings/lib/strings/reportabuse.locstring.json';
import { viewAsDynamic } from 'owa-locstrings/lib/strings/viewasdynamic.locstring.json';
import { viewAsOriginal } from 'owa-locstrings/lib/strings/viewasoriginal.locstring.json';
import { closeDeeplinkReadingPane } from 'owa-mail-actions/lib/readingPaneActions';
import { lazyCreateMailReadAdapter } from 'owa-mail-addins';
import { AMPAvailability } from 'owa-mail-amp-store/lib/store/schema/AmpViewState';
import isAmpEnabled from 'owa-mail-amp-store/lib/utils/isAmpEnabled';
import { isJunkEmailEnabledByAdmin } from 'owa-mail-filterable-menu-behavior';
import { lazyResetFocus } from 'owa-mail-focus-manager';
import { lazyPreparePopoutDataForReadingPane } from 'owa-mail-folder-common';
import { MailIcons } from 'owa-mail-icons';
import { lazyCreateRuleFromItem } from 'owa-mail-inbox-rules';
import isInboxRuleEnabledByAdmin from 'owa-mail-inbox-rules/lib/selectors/isInboxRuleEnabledByAdmin';
import { lazyTranslateItem } from 'owa-mail-inline-translation';
import { lazyMarkItemAsReadFromReadingPane } from 'owa-mail-mark-read-actions';
import { Charms, CharmSize } from 'owa-mail-reading-pane-infobar-view';
import checkItemReplyForwardDisabled from 'owa-mail-reading-pane-item-actions/lib/utils/checkItemReplyForwardDisabled';
import { tryGetNewFocusedNodeOnDelete } from 'owa-mail-reading-pane-store/lib/actions/focusNextPrevItemPart';
import print from 'owa-mail-reading-pane-store/lib/actions/print';
import replyByMeeting from 'owa-mail-reading-pane-store/lib/actions/replyByMeeting';
import setFocusedItemPart from 'owa-mail-reading-pane-store/lib/actions/setFocusedItemPart';
import toggleAmpPreference from 'owa-mail-reading-pane-store/lib/actions/toggleAmpPreference';
import toggleSelectItemPart from 'owa-mail-reading-pane-store/lib/actions/toggleSelectItemPart';
import toggleUndoDarkMode from 'owa-mail-reading-pane-store/lib/actions/toggleUndoDarkMode';
import ItemPartViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemPartViewState';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import { getFocusedItemPart } from 'owa-mail-reading-pane-store/lib/utils/focusedItemPartUtils';
import getConversationSubject from 'owa-mail-reading-pane-store/lib/utils/getConversationSubject';
import getDefaultDisposalType from 'owa-mail-reading-pane-store/lib/utils/getDefaultDisposalType';
import { lazyShowReportAbuseDialog } from 'owa-mail-report-abuse';
import { getAssignPolicyPropertiesForMailContextMenu } from 'owa-mail-retention-policies';
import { ActionSource, ClientItem, InstrumentationContext } from 'owa-mail-store';
import isSenderSelf from 'owa-mail-store/lib/selectors/isSenderSelf';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import getItemRightsManagementRestrictions from 'owa-mail-store/lib/utils/getItemRightsManagementRestrictions';
import { ReadActionKey } from 'owa-outlook-service-options';
import { addPopoutV2, getReadingPaneRouteForPopoutV2 } from 'owa-popout-v2';
import { lazySubscribeToResizeEvent, lazyUnsubscribeFromResizeEvent } from 'owa-resize-event';
import FlagStatus from 'owa-service/lib/contract/FlagStatus';
import Message from 'owa-service/lib/contract/Message';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import doesFolderIdEqualName from 'owa-session-store/lib/utils/doesFolderIdEqualName';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isSignedIn, lazyStartChat, StartChatSource } from 'owa-skype-for-business';
import doesMessageHaveSmimePrefix from 'owa-smime/lib/utils/doesMessageHaveSmimePrefix';
import isSMIMEItem from 'owa-smime/lib/utils/isSMIMEItem';
import { lazyGetSpacesContextMenuItems } from 'owa-timestream-contextmenupicker';
import * as React from 'react';
import {
    itemHeaderUnlike,
    itemHeaderUnflag,
    itemHeaderMarkAsNotJunk,
    itemHeaderLightsOff,
    itemHeaderMessageActions,
} from './ItemActions.locstring.json';
import {
    lazyForwardMessage,
    lazyReplyToMessage,
    lazyGetToCcRecipientsForReply,
    findInlineComposeViewState,
} from 'owa-mail-compose-actions';
import {
    getSelectedTableView,
    getSelectedTableViewId,
    isItemOfMessageType,
    shouldSuppressServerMarkReadOnReplyOrForward,
} from 'owa-mail-list-store';
import {
    isFolderOrSubFolderOfMsgRoot,
    isFolderOfTreeType,
    SHARED_FOLDERS_TREE_TYPE,
    PRIMARY_FOLDERS_TREE_TYPE,
    ARCHIVE_FOLDERS_TREE_TYPE,
} from 'owa-folders';
import {
    lazyBlockLastSenderFromReadingPane,
    lazyDeleteItems,
    lazyLikeItem,
    lazyMarkItemAsPhishingFromReadingPane,
    lazyMarkItemJunkNotJunkFromReadingPane,
    lazySetItemsFlagStateFromItemIds,
    lazyAddMailboxToSafeSenders,
} from 'owa-mail-triage-action';
import {
    getReadStaticActions,
    getReadActionDisplayName,
    getReadActionIconName,
    shouldAddActionToEnd,
    shouldActionBeOnReadingPaneSurface,
    isReadingPaneSurfaceActionPinnedByUser,
    DIVIDER_DISPLAY_NAME,
    SurfaceActionItem,
    ReadStaticAction,
    onCommandBarDataReduced,
    onCommandBarDataGrown,
    logUserAction,
} from 'owa-surface-actions';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    SurfaceActionsOptions,
} from 'owa-outlook-service-options';
import {
    doesUserHaveSharedFolderPermissionFor,
    MenuItemType,
} from 'owa-mail-filterable-menu-behavior';
import {
    lazyInitializeAddinsForItem,
    lazyDeinitializeAddinsForItem,
    MessageReadAdapter,
} from 'owa-addins-core';

const styles = require('./ItemActions.scss');
const classNames = require('classnames/bind').bind(styles);

const DEFAULT_ACTION_SOURCE = 'ReadingPane';

const MaxLocalLikes = 5;
const CHARMS_COMMAND_BAR_ITEM_KEY = 'charms';
const timeoutToInitializeAddins = 1;

export interface ItemActionsProps {
    viewState: ItemViewState;
    item: ClientItem;
    shouldIncludeFullInfo: boolean;
    instrumentationContext: InstrumentationContext;
    isItemAttachment?: boolean;
    isDeeplink?: boolean;
    hideSurfaceButton?: boolean;
    customizedSubsetActionKeys?: string[];
    actionSource?: ActionSource;
    seeMoreStyles?: string;
}

interface ItemHeaderCommandBarData {
    items: SurfaceActionItem[];
    overflowItems: SurfaceActionItem[];
}

interface ItemActionsState {
    addinsInitializedState: AddinsInitializedState;
}

const enum AddinsInitializedState {
    NotStarted,
    Started,
    Finished,
}

@observer
export default class ItemActions extends React.Component<ItemActionsProps, ItemActionsState> {
    private commandBarHiddenOverflowItems: SurfaceActionItem[] = [];
    private commandBarDividerKey: number = 0;
    private commandBar: ICommandBar;
    /*
        This variable just counts the number of repeated likes/unlikes the user has performed locally on the client.
        If the number exceeds MaxLocalLikes, the client UI continues to be updated but no action is sent to the server.
        This is to minimize the impact of repeated like/unlike/like/unlike...
    */
    private likeButtonClickCount: number = 0;
    private likeUnlikeInProgress: boolean = false;
    // Actions that were pinned based on some application logic are tracked here.
    //
    // This is tracked separately from the data dependencies of actions
    // being present in the list, because we want the list of actions to be
    // consistent on an item over its lifetime, even if those data
    // dependencies change
    //
    // e.g. if there are likes on a message, then all users unlike it,
    // we want the like SurfaceAction to still be present with a like count
    // of 0, not
    //
    // This is tracked on the component because we want its lifetime to be tied to the
    // component's lifetime -- e.g. if we unmount the component & remount it (by expanding
    // and collapsing the item, or by switching tabs and switching back), we want to reset
    // the items to be based strictly on the data model.
    private forcePinnedSurfaceActions: Set<ReadActionKey> = new Set();

    constructor(props: ItemActionsProps) {
        super(props);
        this.state = { addinsInitializedState: AddinsInitializedState.NotStarted };
    }

    private disableTranslate(irmRestrictions: IRMRestrictions, message: ClientItem): boolean {
        return (
            !irmRestrictions.CopyAllowed ||
            !irmRestrictions.ForwardAllowed ||
            !irmRestrictions.ReplyAllAllowed ||
            !irmRestrictions.ReplyAllowed ||
            !irmRestrictions.PrintAllowed ||
            !message.TranslationData ||
            !message.TranslationData.userLanguage ||
            message.TranslationData.isShowingTranslation ||
            message.TranslationData.isTranslating
        );
    }

    private shouldAddBlockSafeSenderMenuItemForFolder(item: Message): boolean {
        // should only show block option if in the proper folder, user cannot block themselves
        return (
            !doesFolderIdEqualName(item.ParentFolderId.Id, 'drafts') &&
            item.Sender &&
            item.Sender.Mailbox &&
            !isSenderSelf(item.Sender.Mailbox.EmailAddress) &&
            getSenderNameForBlockMenuItem(item) != null
        );
    }

    private shouldAddAssignPolicyMenuItem(folderId: string): boolean {
        // TODO 133154: Enable Item level retention policies when UpdateItem substrate API is fixed for applying policies in groups
        if (this.isGroupItem()) {
            return false;
        }

        return (
            isFolderOfTreeType(folderId, PRIMARY_FOLDERS_TREE_TYPE) ||
            isFolderOfTreeType(folderId, ARCHIVE_FOLDERS_TREE_TYPE) ||
            isFolderOfTreeType(folderId, 'favorites')
        );
    }

    private blockMenuItemName(message: Message): string {
        return format(loc(itemHeaderBlock), getSenderNameForBlockMenuItem(message));
    }

    private createCommandBarItems(
        IRMRestrictions: IRMRestrictions,
        isSMIME: boolean
    ): ItemHeaderCommandBarData {
        // Actions will be rendered both on the surface (when pinned) *AND* in the overflow.
        // To support this behavior, we override the reduce/grow logic of the commandBar and push items to our own local overflow collection.
        // This collection will not be read by the commandBar, but we need to clear it each time we construct the commandBarData.
        this.commandBarHiddenOverflowItems = [];

        const surfaceItems: SurfaceActionItem[] = [];
        const overflowItems: SurfaceActionItem[] = [];
        const readStaticActions = getReadStaticActions();

        const staticActions =
            this.props.customizedSubsetActionKeys &&
            this.props.customizedSubsetActionKeys.length > 0
                ? readStaticActions.filter(
                      action => this.props.customizedSubsetActionKeys.indexOf(action.key) > -1
                  )
                : readStaticActions;

        const [
            isReplyDisabled,
            isReplyAllDisabled,
            isForwardDisabled,
        ] = checkItemReplyForwardDisabled(
            this.props.item,
            this.props.viewState.isConversationItemPart
        );
        staticActions.forEach(action => {
            const commandBarItem = this.tryCreateStaticActionCommandBarItem(
                action,
                IRMRestrictions,
                isSMIME,
                isReplyDisabled,
                isReplyAllDisabled,
                isForwardDisabled
            );

            if (commandBarItem) {
                const readActionKey = action.key as ReadActionKey;

                if (this.props.hideSurfaceButton) {
                    // If the setting is hide surface button, then add all the buttons in overflow
                    this.addItemToCommandBarOverflow(readActionKey, overflowItems, commandBarItem);
                } else {
                    // Create a potential clone for the commandBarItem initially pointing to the same object.
                    let commandBarItemClone = commandBarItem;

                    // Add the item to the surface only if we're including full info or the rp-selectionUI flight is enabled, and it's pinned.
                    const addItemToSurface =
                        (this.props.shouldIncludeFullInfo || isFeatureEnabled('rp-selectionUI')) &&
                        // Also add the item to the surface if it was _previously_ *forced* to the surface on this item
                        (shouldActionBeOnReadingPaneSurface(readActionKey, this.props.item) ||
                            this.forcePinnedSurfaceActions.has(readActionKey));

                    // Track if this item was forced to the item surface by
                    // some item state.
                    if (
                        addItemToSurface &&
                        !isReadingPaneSurfaceActionPinnedByUser(readActionKey)
                    ) {
                        this.forcePinnedSurfaceActions.add(readActionKey);
                    }

                    if (addItemToSurface) {
                        // If we're adding this item to the surface, create an actual clone for the overflow and add it to the surface.
                        commandBarItemClone = { ...commandBarItem };
                        this.addItemToCommandBarSurface(
                            readActionKey,
                            surfaceItems,
                            commandBarItem
                        );
                    }

                    // Always add the "clone" to the overflow collection. This will either be a copy of the original item,
                    // or the original item if it didn't get added to the surface.
                    this.addItemToCommandBarOverflow(
                        readActionKey,
                        overflowItems,
                        commandBarItemClone
                    );
                }
            }
        });

        this.tryCreateAddinsCommandBarItems(surfaceItems, overflowItems);

        if (!(this.props.shouldIncludeFullInfo || isFeatureEnabled('rp-selectionUI'))) {
            // For experiment users, if we're not including full info or the rp-selectionUI flight is disabled, push the charms to the surface of the command bar to render next to the menu button.
            surfaceItems.push({
                key: CHARMS_COMMAND_BAR_ITEM_KEY,
                onRender: () => {
                    return (
                        <div className={styles.surfaceActionsCommandBarCharms}>
                            {this.renderCharms()}
                        </div>
                    );
                },
            });
        }

        return {
            items: !this.props.hideSurfaceButton ? surfaceItems : [],
            overflowItems: overflowItems,
        };
    }

    private addItemToCommandBarSurface(
        key: ReadActionKey,
        surfaceItems: SurfaceActionItem[],
        item: SurfaceActionItem
    ): void {
        item.isPinned = true; // Mark the item as pinned for telemetry.
        if (shouldAddActionToEnd(key)) {
            surfaceItems.push(item);
        } else {
            surfaceItems.unshift(item);
        }
    }

    private addItemToCommandBarOverflow(
        key: ReadActionKey,
        overflowItems: SurfaceActionItem[],
        item: SurfaceActionItem
    ): void {
        item.renderedInOverflow = true; // Mark the item as renderedInOverflow for telemetry.
        item.onRender = null; // Remove any custom rendering.
        if (key == '-') {
            this.tryAddDivider(overflowItems, item);
        } else {
            overflowItems.push(item);
        }
    }

    private tryAddDivider(items: SurfaceActionItem[], divider: SurfaceActionItem) {
        const itemLength = items.length;
        if (itemLength > 0 && items[itemLength - 1].displayName != DIVIDER_DISPLAY_NAME) {
            items.push(divider);
        }
    }

    private tryCreateStaticActionCommandBarItem(
        action: ReadStaticAction,
        IRMRestrictions: IRMRestrictions,
        isSMIME: boolean,
        isReplyDisabled: boolean,
        isReplyAllDisabled: boolean,
        isForwardDisabled: boolean
    ): SurfaceActionItem {
        if (
            (action.hideInGroup && this.isGroupItem()) ||
            (action.hideInSxS && this.props.isItemAttachment)
        ) {
            return null;
        }

        const actionKey = action.key as ReadActionKey;
        let displayName = getReadActionDisplayName(actionKey);
        let iconName = getReadActionIconName(actionKey).iconName;
        let subMenuProps = null;
        let isDisabled = false;
        let customRender = null;
        let datapointName = action.key as string;
        let clickHandler: (
            ev?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>
        ) => boolean | void;
        const message: Message = this.props.item;
        switch (actionKey) {
            case 'LikeUnlike':
                if (
                    !isConsumer() &&
                    !isFolderOfTreeType(message.ParentFolderId.Id, SHARED_FOLDERS_TREE_TYPE)
                ) {
                    const userEmailAddress = getUserConfiguration().SessionSettings
                        .UserEmailAddress;
                    const hasUserLikedMessage = message.Likers
                        ? message.Likers.some(email => email.EmailAddress === userEmailAddress)
                        : false;

                    clickHandler = this.onLikeUnLike();

                    if (hasUserLikedMessage) {
                        iconName = MailIcons.LikeSolid;
                        displayName = loc(itemHeaderUnlike);
                    }

                    // Set a custom render if present on the surface
                    if (shouldActionBeOnReadingPaneSurface(actionKey, this.props.item)) {
                        customRender = this.renderLikeCustomButtonMenuItem;
                    }
                }
                break;
            case 'ToggleAmp':
                const { preferAmp, ampAvailability } = this.props.viewState.ampViewState;
                if (isAmpEnabled() && ampAvailability == AMPAvailability.AmpValidated) {
                    displayName = preferAmp ? loc(viewAsOriginal) : loc(viewAsDynamic);
                    datapointName = preferAmp ? 'ViewAsOriginal' : 'ViewAsDynamic';
                    clickHandler = this.onToggleAmp;
                }
                break;
            case 'Reply':
                clickHandler = this.onReply;
                isDisabled = isReplyDisabled;
                break;
            case 'ReplyAll':
                clickHandler = this.onReplyAll;
                isDisabled = isReplyAllDisabled;
                break;
            case 'Forward':
                clickHandler = this.onForward;
                isDisabled = isForwardDisabled;
                break;
            case 'ReplyByMeeting':
                clickHandler = this.onReplyByMeeting;
                isDisabled = isSMIME;
                break;
            case 'Popout':
                clickHandler = this.onPopout;
                break;
            case 'Delete':
                if (
                    !this.props.isItemAttachment &&
                    doesUserHaveSharedFolderPermissionFor(
                        MenuItemType.Delete
                    ) /* check for shared folder permission */
                ) {
                    clickHandler = this.onDelete;
                    isDisabled = this.isGroupItem()
                        ? !message.CanDelete
                        : false; /* Use canDelete property for group messages */
                }
                break;
            case 'MarkReadUnread':
                /* Temporarily disable for groups popouts */
                if (!this.isGroupPopout()) {
                    displayName = message.IsRead ? loc(markAsUnread) : loc(markAsRead); // Override default string based on actual state
                    datapointName = message.IsRead ? 'MarkItemUnread' : 'MarkItemRead';
                    clickHandler = this.onToggleReadMenuItem;
                    if (!message.IsRead) {
                        iconName = ControlIcons.Read;
                    }
                }
                break;
            case 'FlagUnflag':
                if (
                    doesUserHaveSharedFolderPermissionFor(
                        MenuItemType.Flag
                    ) /* check for shared folder permission */
                ) {
                    const isUnflag = !message.Flag || message.Flag.FlagStatus != 'Flagged';
                    displayName = isUnflag ? loc(itemHeaderFlag) : loc(itemHeaderUnflag); // Override default string based on actual state
                    datapointName = isUnflag ? 'FlagItem' : 'UnflagItem';
                    clickHandler = this.onToggleFlagMenuItem;
                }
                break;
            case 'AssignPolicy':
                if (this.shouldAddAssignPolicyMenuItem(message.ParentFolderId.Id)) {
                    clickHandler = this.onAssignPolicy;
                    const selectedTableView = getSelectedTableView();
                    subMenuProps = getAssignPolicyPropertiesForMailContextMenu(
                        selectedTableView ? selectedTableView.id : null,
                        'RPCSAOverflow',
                        this.props.item
                    );
                }
                break;
            case 'AddToSafeSenders':
                if (this.shouldAddBlockSafeSenderMenuItemForFolder(message)) {
                    clickHandler = this.onAddToSafeSenders;
                }
                break;
            case 'MarkJunkNotJunk':
                //Checking if Junk Email is enabled from admin and the item is from primary mailbox.
                if (
                    isJunkEmailEnabledByAdmin() &&
                    isFolderOrSubFolderOfMsgRoot(message.ParentFolderId.Id)
                ) {
                    displayName = this.isInJunkFolder
                        ? loc(itemHeaderMarkAsNotJunk)
                        : loc(itemHeaderMarkAsJunk); // Override default string based on actual state
                    datapointName = this.isInJunkFolder ? 'MarkItemNotjunk' : 'MarkItemJunk';
                    clickHandler = this.onToggleJunkNotjunk();
                }
                break;
            case 'MarkAsPhishing':
                clickHandler = this.onPhishing;
                break;
            case 'Block':
                if (
                    this.shouldAddBlockSafeSenderMenuItemForFolder(message) &&
                    isFolderOrSubFolderOfMsgRoot(message.ParentFolderId.Id) //Checking if the item is from primary mailbox
                ) {
                    displayName = this.blockMenuItemName(message); // Override default string based on actual state
                    clickHandler = this.onBlock;
                }
                break;
            case 'ReportAbuse':
                if (isFeatureEnabled('tri-reportAbuse')) {
                    displayName = loc(reportAbuse);
                    clickHandler = this.onReportAbuse;
                }
                break;
            case 'CreateRule':
                if (
                    isInboxRuleEnabledByAdmin() &&
                    this.itemHasSenderSMTP() &&
                    isFolderOrSubFolderOfMsgRoot(message.ParentFolderId.Id) //Checking if the item is from primary mailbox
                ) {
                    clickHandler = this.onCreateRule;
                }
                break;
            case 'Print':
                clickHandler = this.onPrint;
                isDisabled = !IRMRestrictions.PrintAllowed;
                break;
            case 'Translate':
                clickHandler = this.onTranslate;
                isDisabled = this.disableTranslate(IRMRestrictions, this.props.item);
                break;
            case 'ShowInImmersiveReader':
                clickHandler = this.onShowInImmersiveReader;
                break;
            case 'ViewMessageSource':
                // Do not show if user is viewing own sent item in sent folder.
                // This is required because message details are not stamped in this case.
                if (!this.isSentItem) {
                    clickHandler = this.onViewMessageSource;
                }
                break;
            case 'ToggleDarkMode':
                const undoDarkMode = this.props.viewState.undoDarkMode;
                displayName = undoDarkMode ? loc(itemHeaderLightsOff) : loc(itemHeaderLightsOn);
                iconName = undoDarkMode ? ControlIcons.ClearNight : ControlIcons.Sunny;
                datapointName = undoDarkMode ? 'ToggleDarkModeOn' : 'ToggleDarkModeOff';
                clickHandler = this.onToggleUndoDarkMode;
                break;
            case 'ReplyByIM':
                clickHandler = this.replyByIm;
                isDisabled = !isSignedIn();
                break;
            case 'ReplyAllByIM':
                clickHandler = this.replyAllByIm;
                isDisabled = !isSignedIn();
                break;
            case 'AddToProjectSpace':
                const spacesSubMenuProps = lazyGetSpacesContextMenuItems.tryImportForRender();
                if (spacesSubMenuProps) {
                    clickHandler = this.onAddToProjectSpace;
                    subMenuProps = spacesSubMenuProps(this.props.item.ItemId.Id, this.props.item);
                }
                break;
            case '-':
                return {
                    key: (this.commandBarDividerKey++).toString(),
                    displayName: DIVIDER_DISPLAY_NAME,
                    itemType: ContextualMenuItemType.Divider,
                    onClick: null,
                };
        }

        if (clickHandler) {
            return {
                key: actionKey,
                name: displayName,
                iconProps: {
                    iconName: iconName,
                    className: styles.commandBarIcon,
                },
                onRender: customRender,
                disabled: isDisabled,
                onClick: this.getHandler(clickHandler, true /*isMouse*/, datapointName),
                onKeyDown: this.getHandler(clickHandler, false /*isMouse*/, datapointName),
                iconOnly: true,
                ariaLabel: displayName,
                subMenuProps: subMenuProps,
            };
        } else {
            return null;
        }
    }

    private tryCreateAddinsCommandBarItems(
        surfaceItems: SurfaceActionItem[],
        overflowItems: SurfaceActionItem[]
    ) {
        // Do not create addins command bar items if they have not finished initializing
        if (this.state.addinsInitializedState != AddinsInitializedState.Finished) {
            return;
        }

        const addinsSurfaceItems: SurfaceActionItem[] = [];
        const addinsOverflowItems: SurfaceActionItem[] = [];
        const surfaceActionsOptions = getOptionsForFeature<SurfaceActionsOptions>(
            OwsOptionsFeatureType.SurfaceActions
        );
        const datapointName = 'Addins';
        let focusedItemId: string;

        if (this.props.viewState.isConversationItemPart && isFeatureEnabled('rp-selectionUI')) {
            // With rp-selectionUI, although we show addin on all expanded item parts, we only support one copy of addin.
            // To ensure the addin associated with the correct "hostItemIndex", we should use "focusedItemId" as the "hostItemIndex" to populate addin on all expanded item parts.
            const focusedItemPart = getFocusedItemPart();
            focusedItemId = focusedItemPart?.itemId;
        }

        populateCommandBarWithAddins(
            ExtensibilityModeEnum.MessageRead,
            this.props.item,
            focusedItemId || this.props.item.ItemId.Id,
            surfaceActionsOptions.readSurfaceAddins,
            addinsSurfaceItems,
            addinsOverflowItems,
            true /* isEndAligned */,
            this.commandBarDividerKey,
            null /* className*/,
            true /* alwaysAddToOverflow */
        );

        [...addinsSurfaceItems, ...addinsOverflowItems].forEach(item => {
            if (item.onClick) {
                const clickHandler = item.onClick;
                item.onClick = this.getHandler(clickHandler, true /** isMouse */, datapointName);
                item.onKeyDown = this.getHandler(clickHandler, false /** isMouse */, datapointName);
            }
        });

        surfaceItems.unshift(...addinsSurfaceItems);
        overflowItems.push(...addinsOverflowItems);
    }

    private getHandler = (
        handler: (
            ev?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
            item?: SurfaceActionItem
        ) => boolean | void,
        isMouse: boolean,
        datapointName: string
    ) => {
        return (
            ev?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
            item?: SurfaceActionItem
        ) => {
            // Log the user action for all the surface actions
            logUserAction(
                false /*isCompose*/,
                datapointName,
                item,
                this.getActionSource(item) as string
            );

            if (isMouse) {
                this.updateSelectItemPart();
                handler(ev, item);
            } else {
                if ((ev as React.KeyboardEvent<HTMLElement>).which == KeyCodes.enter) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    this.updateSelectItemPart();
                    handler(ev, item);
                }
            }
        };
    };

    private updateSelectItemPart = () => {
        if (this.props.viewState.isConversationItemPart) {
            // Update item part selection when trigger surface action button
            toggleSelectItemPart(
                this.props.viewState as ItemPartViewState,
                false /*toggleExpandedCollapsed*/
            );
        }
    };

    componentDidMount() {
        lazySubscribeToResizeEvent.importAndExecute(this.onResize);
        this.initailizeAddinsIfNeeded();
    }

    componentWillUnmount() {
        lazyUnsubscribeFromResizeEvent.importAndExecute(this.onResize);
        this.deInitializeAddins();
    }

    componentDidUpdate() {
        this.initailizeAddinsIfNeeded();
    }

    render() {
        const isNotInNotesFolder = this.props.item.ParentFolderId
            ? !doesFolderIdEqualName(this.props.item.ParentFolderId.Id, 'notes')
            : true;

        return (
            <div className={styles.surfaceActionsCommandBarContainer}>
                {isNotInNotesFolder && this.renderCommandBar()}
            </div>
        );
    }

    private renderCommandBar(): JSX.Element {
        if (!this.props.viewState) {
            return null;
        }

        const IRMRestrictions = getItemRightsManagementRestrictions(this.props.item);
        const isSMIME = isSMIMEItem(this.props.item);
        const commandBarData = this.createCommandBarItems(IRMRestrictions, isSMIME);

        return (
            <CommandBar
                componentRef={this.getRef}
                items={commandBarData.items}
                overflowItems={commandBarData.overflowItems}
                overflowButtonProps={{
                    iconProps: {
                        iconName: ControlIcons.More,
                    },
                    menuIconProps: {
                        iconName: ControlIcons.More,
                        styles: {
                            root: isStringNullOrWhiteSpace(this.props.seeMoreStyles)
                                ? styles.surfaceActionsCommandBarOverflowIcon
                                : classNames(
                                      styles.surfaceActionsCommandBarOverflowIcon,
                                      this.props.seeMoreStyles
                                  ),
                        },
                    },
                    ariaLabel: loc(mailEllipsisAriaLabelText),
                }}
                buttonAs={this.ItemHeaderToolbarButton}
                overflowButtonAs={this.ItemHeaderToolbarOverflowButton}
                shiftOnReduce={true}
                onDataReduced={onCommandBarDataReduced}
                onDataGrown={onCommandBarDataGrown}
                styles={{
                    root: styles.surfaceActionsCommandBar,
                    primarySet: styles.surfaceActionsCommandBarPrimarySet,
                }}
                ariaLabel={loc(itemHeaderMessageActions)}
                onReduceData={this.onCommandBarReduceData}
                onGrowData={this.onCommandBarGrowData}
            />
        );
    }

    private getRef = (ref: ICommandBar) => {
        this.commandBar = ref;
    };

    // Until https://github.com/OfficeDev/office-ui-fabric-react/issues/5300 is fixed, we need to intercept props.menuProps and add
    // directionalHint, onMenuOpened, and onMenuDismissed here if the menuProps exist.
    private ItemHeaderToolbarButton = observerLite((props: IButtonProps) => (
        <CommandBarButton
            {...props}
            menuProps={
                props.menuProps && {
                    ...props.menuProps,
                    directionalHint: DirectionalHint.bottomAutoEdge,
                }
            }
            onMenuClick={
                // Some add-in surface buttons are menu buttons.
                // In Office UI Fabric, a menu button's default onClick/onKeyDown behavior is open contexual menu,
                // to add extra common handling, we need to provide onMenuClick prop here.
                this.updateSelectItemPart
            }
            styles={{
                ...props.styles,
                root: classNames(styles.surfaceActionsCommandBarButton, styles.iconButton),
                rootChecked: styles.checkedCommandBarButton,
                rootDisabled: styles.disabledReplyActionButton,
                icon: styles.enabledIconButton,
                iconDisabled: styles.disabledIconButton,
                menuIcon: styles.commandBarMenuIcon,
            }}
            role={'button'}
        />
    ));

    private ItemHeaderToolbarOverflowButton = observerLite((props: IButtonProps) => {
        const ToolbarButton: (props: IButtonProps) => JSX.Element = this.ItemHeaderToolbarButton;
        return (
            <TooltipHost content={loc(MoreActionsButton)}>
                <ToolbarButton {...props} />
            </TooltipHost>
        );
    });

    private renderCharms(): JSX.Element {
        const { item, viewState, instrumentationContext } = this.props;
        return (
            <Charms
                message={item}
                viewState={viewState}
                instrumentationContext={instrumentationContext}
                charmSize={CharmSize.size16}
                hideAttachmentIcon={true} // Never show attachment charm in itemHeader as it's redundant with the attachment well below.
                hideCharmlessIcon={true}
            />
        );
    }

    private onCommandBarReduceData = (data: any): any => {
        // Logic copied from fabric's commandBar with some changes.
        // Called on a resize when the commandBar attempts to remove an item from the surface.
        // VSO #31334 data type is currently 'any' as fabric doesn't yet export the proper ICommandBarData type.
        let { primaryItems, overflowItems, cacheKey } = data;

        // Get the first item in the primary (surface) collection.
        const movedItem = primaryItems[0];

        if (movedItem !== undefined) {
            // If it exists, add it to the start of our local collection of hidden overflow items,
            // remove it from the primary (surface) collection, compute the cacheKey, and return the new data.
            this.commandBarHiddenOverflowItems = [movedItem, ...this.commandBarHiddenOverflowItems];
            primaryItems = primaryItems.slice(1);
            cacheKey = this.computeCommandBarCacheKey(primaryItems);

            return { ...data, primaryItems, overflowItems, cacheKey };
        }

        // If we have no more primary (surface) items to reduce, return undefined so the commandBar's resize logic will stop.
        return undefined;
    };

    private onCommandBarGrowData = (data: any): any => {
        // Logic copied from fabric's command bar with some changes.
        // Called on a resize when the commandBar attempts to add an item back to the surface.
        // VSO #31334 data type is currently 'any' as fabric doesn't yet export the proper ICommandBarData type.
        let { primaryItems, overflowItems, cacheKey } = data;

        // Get the first item from our local collection of hidden overflow items.
        const movedItem = this.commandBarHiddenOverflowItems[0];

        if (movedItem !== undefined) {
            // If it exists, remove it from our local collection of hidden overflow items,
            // add it to the start of the primary (surface) collection, compute the cacheKey, and return the new data.
            this.commandBarHiddenOverflowItems = this.commandBarHiddenOverflowItems.slice(1);
            primaryItems = [movedItem, ...primaryItems];
            cacheKey = this.computeCommandBarCacheKey(primaryItems);

            return { ...data, primaryItems, overflowItems, cacheKey };
        }

        // If we have no more hidden overflow items to add back to the primary (surface) collection, return undefined so the commandBar's resize logic will stop.
        return undefined;
    };

    private computeCommandBarCacheKey(primaryItems: SurfaceActionItem[]) {
        // Logic copied from fabric's command bar with some changes.
        const returnKey = (acc: string, current: SurfaceActionItem): string => {
            const { cacheKey = current.key } = current;
            return acc + cacheKey;
        };

        const primaryKey = primaryItems.reduce(returnKey, '');
        const farKey = ''; // We never have far items, always use an empty string.
        const overflowKey = 'overflow'; // We always have an overflow button, always use 'overflow'

        return [primaryKey, farKey, overflowKey].join(' ');
    }

    private onResize = () => {
        if (this.commandBar) {
            this.commandBar.remeasure();
        }
    };

    private getConversationId() {
        return this.props.viewState.isConversationItemPart && this.props.item.ConversationId
            ? this.props.item.ConversationId.Id
            : null;
    }

    private isGroupPopout(): boolean {
        return this.props.isDeeplink && this.isGroupItem();
    }

    private isGroupItem(): boolean {
        return this.props.item.MailboxInfo
            ? this.props.item.MailboxInfo.type === MailboxType.GroupMailbox
            : false;
    }

    @computed
    private get isInJunkFolder(): boolean {
        const message: Message = this.props.item;
        return doesFolderIdEqualName(message.ParentFolderId.Id, 'junkemail');
    }

    @computed
    private get isSentItem(): boolean {
        const message: Message = this.props.item;
        return doesFolderIdEqualName(message.ParentFolderId.Id, 'sentitems');
    }

    private onPopout = (event: React.MouseEvent<HTMLElement>, item?: SurfaceActionItem) => {
        event.stopPropagation();
        const route = getReadingPaneRouteForPopoutV2(
            this.props.item.MailboxInfo,
            this.props.viewState.itemId
        );
        addPopoutV2('mail', route, async () => {
            const preparePopoutDataForReadingPane = await lazyPreparePopoutDataForReadingPane.import();
            return preparePopoutDataForReadingPane(getSelectedTableView());
        });
    };

    private replyByIm = (event: React.MouseEvent<HTMLElement>, item?: SurfaceActionItem) => {
        this.replyByImInternal(false /* isReplyAll */);
    };

    private replyAllByIm = (event: React.MouseEvent<HTMLElement>, item?: SurfaceActionItem) => {
        this.replyByImInternal(true /* isReplyAll */);
    };

    private async replyByImInternal(isReplyAll: boolean) {
        const referenceItem = this.props.item as Message;
        const getAllRecipients = await lazyGetToCcRecipientsForReply.import();
        const [toRecipients, ccRecipients] = await getAllRecipients(referenceItem, isReplyAll);
        const allRecipients = [...toRecipients, ...ccRecipients].map(recipient => {
            return recipient.SipUri ? recipient.SipUri : 'sip:' + recipient.EmailAddress;
        });
        if (allRecipients.length > 0) {
            lazyStartChat
                .import()
                .then(startChat =>
                    startChat(
                        allRecipients,
                        referenceItem.Subject,
                        isReplyAll ? StartChatSource.ReplyAllByIm : StartChatSource.ReplyByIm
                    )
                );
        }
    }

    private onReply = (event: React.MouseEvent<HTMLElement>, item?: SurfaceActionItem) => {
        this.onReplyReplyAllInternal(event, false /* isReplyAll */, item);
    };

    private onReplyAll = (event: React.MouseEvent<HTMLElement>, item?: SurfaceActionItem) => {
        this.onReplyReplyAllInternal(event, true /* isReplyAll */, item);
    };

    private onReplyReplyAllInternal = (
        event: React.MouseEvent<HTMLElement>,
        isReplyAll: boolean,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();

        const conversationId = this.props.item.ConversationId
            ? this.props.item.ConversationId.Id
            : null;

        // We use the inline compose only when conversationId is defined (e.g.: we are in Conversation View)
        // or when the item is translated.
        const useInlineCompose =
            isFeatureEnabled('cmp-inlineTranslation') &&
            this.props.item.TranslationData &&
            (this.props.item.TranslationData.isShowingTranslation ||
                this.props.item.TranslationData.isShowingForwardContentTranslation);

        lazyReplyToMessage.importAndExecute({
            referenceItemId: {
                ...this.props.item.ItemId,
                mailboxInfo: this.props.item.MailboxInfo,
            },
            isReplyAll: isReplyAll,
            useFullCompose: !useInlineCompose && !this.props.viewState.isConversationItemPart,
            actionSource: DEFAULT_ACTION_SOURCE,
            instrumentationContexts: [this.props.instrumentationContext],
            conversationId: conversationId,
            suppressServerMarkReadOnReplyOrForward: shouldSuppressServerMarkReadOnReplyOrForward(
                getSelectedTableView()
            ),
        });
    };

    private onForward = (event: React.MouseEvent<HTMLElement>, item?: SurfaceActionItem) => {
        event.stopPropagation();

        lazyForwardMessage.importAndExecute(
            {
                ...this.props.item.ItemId,
                mailboxInfo: this.props.item.MailboxInfo,
            },
            DEFAULT_ACTION_SOURCE,
            [this.props.instrumentationContext],
            shouldSuppressServerMarkReadOnReplyOrForward(getSelectedTableView())
        );
    };

    private onReplyByMeeting = (event: React.MouseEvent<HTMLElement>, item?: SurfaceActionItem) => {
        event.stopPropagation();

        const message = isItemOfMessageType(this.props.item) ? (this.props.item as Message) : null;

        replyByMeeting(
            this.props.item.ItemId.Id,
            null /*calendarInlineComposeViewState*/,
            false /*shouldSend*/,
            DEFAULT_ACTION_SOURCE,
            null /*extractionEntityId*/,
            message?.InternetMessageId /*internetMessageId*/ /*internetMessageId*/
        );
    };

    private onLikeUnLike = () => (
        event: React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();
        if (!this.likeUnlikeInProgress && item) {
            this.likeUnlikeInProgress = true;
            this.asyncLikeItem(item);
        }
    };

    private asyncLikeItem = async (item?: SurfaceActionItem) => {
        const likeItem = await lazyLikeItem.import();
        this.likeButtonClickCount++;
        likeItem(
            {
                ...this.props.item.ItemId,
                mailboxInfo: this.props.item.MailboxInfo,
            },
            this.props.item as Message,
            getSelectedTableView(),
            this.likeButtonClickCount >= MaxLocalLikes /* isLocalUpdateOnly */,
            this.props.instrumentationContext
        );

        this.likeUnlikeInProgress = false;
    };

    private onDelete = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();

        const conversationId = this.getConversationId();
        if (conversationId && isFeatureEnabled('rp-selectionUI')) {
            const newFocusedNode = tryGetNewFocusedNodeOnDelete(
                conversationId,
                this.props.viewState as ItemPartViewState
            );
            lazyDeleteItems
                .importAndExecute(
                    [this.props.item.ItemId.Id],
                    getDefaultDisposalType(this.props.item.ItemId.Id),
                    [this.props.instrumentationContext],
                    DEFAULT_ACTION_SOURCE,
                    this.props.item.MailboxInfo,
                    true /* disableResetFocus */
                )
                .then(() => {
                    // set focusedItemPart in the callback is to make sure itemPartDiv.focus() scroll to the correct position
                    setFocusedItemPart(newFocusedNode, conversationId);
                });
        } else {
            lazyDeleteItems
                .importAndExecute(
                    [this.props.item.ItemId.Id],
                    getDefaultDisposalType(this.props.item.ItemId.Id),
                    [this.props.instrumentationContext],
                    DEFAULT_ACTION_SOURCE,
                    this.props.item.MailboxInfo
                )
                .then(() => {
                    closeDeeplinkReadingPane();
                });
        }
    };

    private onToggleJunkNotjunk = () => (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();

        lazyMarkItemJunkNotJunkFromReadingPane
            .importAndExecute(
                this.props.item.ItemId.Id,
                getSelectedTableView(),
                DEFAULT_ACTION_SOURCE,
                [this.props.instrumentationContext]
            )
            .then(() => {
                closeDeeplinkReadingPane();
            });
        lazyResetFocus.importAndExecute();
    };

    private onPhishing = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();

        lazyMarkItemAsPhishingFromReadingPane
            .importAndExecute(
                this.props.item.ItemId.Id,
                getSelectedTableView(),
                DEFAULT_ACTION_SOURCE
            )
            .then(() => {
                closeDeeplinkReadingPane();
            });
        lazyResetFocus.importAndExecute();
    };

    private onReportAbuse = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();

        lazyShowReportAbuseDialog.importAndExecute(
            this.props.item,
            getSelectedTableView(),
            [this.props.instrumentationContext],
            DEFAULT_ACTION_SOURCE
        );
        lazyResetFocus.importAndExecute();
    };

    private onBlock = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();

        lazyBlockLastSenderFromReadingPane.importAndExecute(
            this.props.item.ItemId.Id,
            [this.props.instrumentationContext],
            DEFAULT_ACTION_SOURCE
        );
        lazyResetFocus.importAndExecute();
    };

    private onToggleReadMenuItem = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();
        const message: Message = this.props.item;

        lazyMarkItemAsReadFromReadingPane.importAndExecute(
            this.props.item.ItemId.Id,
            getSelectedTableView(),
            !message.IsRead,
            [this.props.instrumentationContext],
            DEFAULT_ACTION_SOURCE
        );
    };

    private onToggleFlagMenuItem = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();
        let flagStatusValueToSet: FlagStatus;
        if (this.props.item.Flag.FlagStatus != 'Flagged') {
            flagStatusValueToSet = 'Flagged';
        } else {
            flagStatusValueToSet = 'NotFlagged';
        }

        lazySetItemsFlagStateFromItemIds.importAndExecute(
            [this.props.item.ItemId.Id],
            [this.props.instrumentationContext],
            { FlagStatus: flagStatusValueToSet },
            getSelectedTableViewId(),
            DEFAULT_ACTION_SOURCE
        );
    };

    private onAddToSafeSenders = (
        event: React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();
        const message = this.props.item as Message;

        lazyAddMailboxToSafeSenders.import().then(addMailboxToSafeSenders => {
            addMailboxToSafeSenders(
                message.Sender.Mailbox,
                message.ItemId.Id,
                this.getActionSource(item)
            );
        });
    };

    // This can be handled in the sub menu utility itself. No need of implementation here
    private onAssignPolicy(
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) {
        event.stopPropagation();
    }

    private onCreateRule = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();

        const message = this.props.item as Message;
        lazyCreateRuleFromItem.import().then(createRuleFromItem => {
            createRuleFromItem(message, this.getActionSource(item) as InboxRuleActionSource);
        });
    };

    private onPrint = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();

        print(
            {
                ...this.props.item.ItemId,
                mailboxInfo: this.props.item.MailboxInfo,
            },
            DEFAULT_ACTION_SOURCE
        );
    };

    private onTranslate = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();

        lazyTranslateItem.importAndExecute(
            this.props.item.ItemId.Id,
            getConversationSubject(),
            this.props.viewState.isConversationItemPart,
            true
        );
    };

    private onShowInImmersiveReader = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();

        showInImmersiveReader(
            {
                ...this.props.item.ItemId,
                mailboxInfo: this.props.item.MailboxInfo,
            },
            DEFAULT_ACTION_SOURCE,
            this.getActionSource(item)
        );
    };

    private onViewMessageSource = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();

        logUsage(
            'ViewMessageSource',
            {
                subActionSource: this.getActionSource(item),
            },
            {
                actionSource: DEFAULT_ACTION_SOURCE,
            }
        );

        openMessageSourceDialog(this.props.item);
    };

    private onToggleAmp = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>
    ) => {
        event.stopPropagation();
        toggleAmpPreference(this.props.viewState.ampViewState);
    };

    private onToggleUndoDarkMode = (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();

        toggleUndoDarkMode(this.props.viewState);
    };

    private itemHasSenderSMTP(): boolean {
        const message = isItemOfMessageType(this.props.item) ? (this.props.item as Message) : null;
        return !!message?.From?.Mailbox;
    }

    private renderLikeCustomButtonMenuItem = (item: SurfaceActionItem) => {
        return <CustomLikeButton surfaceActionItem={item} message={this.props.item} />;
    };

    private onAddToProjectSpace(
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) {
        event.stopPropagation();
    }

    private shouldAddinsPopulate(): boolean {
        const shouldIncludeFullInfo =
            (!this.props.customizedSubsetActionKeys ||
                this.props.customizedSubsetActionKeys.length == 0) &&
            this.props.shouldIncludeFullInfo;
        return (
            isFeatureEnabled('rp-addins') &&
            shouldIncludeFullInfo &&
            !findInlineComposeViewState(this.getConversationId()) &&
            !this.props.isItemAttachment &&
            shouldAddinsActivate(this.props.item) &&
            !this.isGroupItem() &&
            !doesMessageHaveSmimePrefix(this.props.item)
        );
    }

    private initailizeAddinsIfNeeded() {
        if (
            this.state.addinsInitializedState == AddinsInitializedState.NotStarted &&
            this.shouldAddinsPopulate()
        ) {
            this.setState({ addinsInitializedState: AddinsInitializedState.Started });
            setTimeout(() => {
                this.initializeAddins();
            }, timeoutToInitializeAddins);
        }
    }

    private initializeAddins() {
        isFeatureEnabled('rp-addins') &&
            lazyCreateMailReadAdapter.import().then(createMailReadAdapter => {
                const adapter: MessageReadAdapter = createMailReadAdapter(
                    this.props.item,
                    this.props.viewState as ItemPartViewState
                );
                lazyInitializeAddinsForItem.import().then(initializeAddinsForItem => {
                    initializeAddinsForItem(
                        getReadHostItemIndex(this.props.item.ItemId.Id),
                        adapter
                    );
                    this.setState({ addinsInitializedState: AddinsInitializedState.Finished });
                });
            });
    }

    private deInitializeAddins() {
        if (this.state.addinsInitializedState == AddinsInitializedState.NotStarted) {
            return;
        }
        isFeatureEnabled('rp-addins') &&
            lazyDeinitializeAddinsForItem.import().then(deinitializeAddinsForItem => {
                deinitializeAddinsForItem(getReadHostItemIndex(this.props.item.ItemId.Id));
            });
    }

    private getActionSource(item: SurfaceActionItem): ActionSource {
        let actionSource: ActionSource = 'RPCSAPinned';
        if (item?.renderedInOverflow) {
            // If the item is rendered in the overflow, it either wasn't pinned to begin with or
            // was moved to the overflow due to limited space.
            if (item.isPinned) {
                actionSource = 'RPCSAOverflow';
            } else {
                actionSource = 'RPCSANotPinned';
            }
        }

        // Use the action source in props
        if (this.props.actionSource) {
            actionSource = this.props.actionSource;
        }

        return actionSource;
    }
}
